
import React from "react";
import { Cross, MapPin } from "lucide-react";
import { formatDateForDisplay } from "@/utils/dateUtils";

interface DeathInfoCardProps {
  deathDate: string;
  deathPlace: string;
  personLabel?: string;
}

export const DeathInfoCard: React.FC<DeathInfoCardProps> = ({ deathDate, deathPlace, personLabel }) => {
  if (!deathDate && !deathPlace) return null;

  return (
    <div className="bg-card rounded-xl shadow-sm border overflow-hidden transition-all duration-300 hover:shadow-md">
      <div className="border-b bg-muted/30 px-6 py-4 flex items-center">
        <Cross className="h-5 w-5 text-primary mr-2" />
        <h3 className="font-medium text-foreground">{personLabel ? `${personLabel}'s Death` : 'Death'}</h3>
      </div>
      <div className="p-6">
        <div className="space-y-2 text-muted-foreground">
          {deathDate && (
            <p className="text-foreground">{formatDateForDisplay(deathDate)}</p>
          )}
          {deathPlace && (
            <div className="flex items-center gap-2 text-sm">
              <MapPin className="h-4 w-4" />
              <span>{deathPlace}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
